import { makeAutoObservable, action as mobAction } from "mobx"
import { manageLocalStorage, Network } from "../util"
import { clearLocalStorage, getEmailDomain } from "../util/helperFunctions"
import { EMAIL_DOMAIN_BLACKLIST } from "../util/constants"
const VERSION =""
class Store {
	constructor() {
		makeAutoObservable(this)
	}

	user = null
	skippedEnrollments = []
	scrollRef = null
	loadingData = false
	disableInput = false

	init = {
		company: "SALUSION",
		adminRoles: [],
		phone: "",
		staticData: {
			irsHdhpData: {},
			availability: [],
			achDebitRoutingNumber: 0,
			themes: {}
		}
	}

	window = {
		scrollY: 0,
		lastScrollY: 0,
		clientWidth: 0
	}

	browser = {
		scrollbarWidth: 0,
		isAppInstalled: true,
		currentRouteObject: null
	}

	util = {
		alertStatus: false,
		alertTemplate: null,
		alertOptions: [],
		notificationStatus: false,
		notificationTemplate: { msg: "", severity: "", action: null },
		helpersStatus: false,
		helpersTemplate: false,
		progressStatus: false,
		progressTemplate: {},
		modalStatus: false,
		query: {},
		popupStatus: false,
		popupTemplate: null,
		popupCoords: {},
		scrollY: 0,
		successHandler: {},
		routeHandler: { data: { data: {}, persist: 0, referer: "" } },
		routeCycler: [],
		globalMountConfig: { isMounted: false }
	}

	flags = {
		isCompanySetup: false
	}

	confirmConfig = {
		anchor: null,
		text: null,
		color: null,
		onCancel: null,
		onConfirm: null
	}

	clearLocalStorage() {
		//@ts-ignore
		const currentVersion = VERSION
		localStorage.clear()
		localStorage.setItem("VERSION", currentVersion)
	}

	async getLoginRoute({ user }) {
		// console.log("in getLoginRoute, user = ", user)
		const noInsuranceEntered = user?.noInsuranceEntered
		if (user.employerAdminEmployer?.id) {
			return "/dashboard"
		} else if (noInsuranceEntered) {
			const plan = user?.currentPlansWithoutSubmittedInsurance?.[0]
			return "/onboarding/manage/" + plan.id
		} else return "/dashboard"
	}

	async initializeApp() {
		try {
			const prevVersion = manageLocalStorage({ action: "GET", key: "VERSION" })
	
			//@ts-ignore
			const currentVersion = VERSION
			if (currentVersion !== prevVersion) this.clearLocalStorage()
	
			const { data } = await Network.AxiosWrapper({
				method: "GET",
				target: "report"
			})
			this.init.staticData = data
			this.setIsCompanySetup({
				isCompanySetup: localStorage.getItem(`company-is-setup-${this.user?.employerAdminEmployer?.id}`)
			})
		} catch (err) {
			console.log("something went wrong",err);		
		}
	}

	async setIsCompanySetup({ isCompanySetup }) {
		localStorage.setItem(`company-is-setup-${this.user?.employerAdminEmployer?.id}`, isCompanySetup)
		this.flags.isCompanySetup = isCompanySetup
	}

	async getUserAppLoad({ user, history }) {
		try {
			this.loadingData = true
			this.user = user
			this.loadingData = false

			return user
		} catch (err) {
			history("/", { replace: true })
			console.error(err)
		}
	}

	async getUser({ user, email, password, history, login }) {
		// console.log("In getUser, user = ", user)
		this.loadingData = true
		console.log("In getUser, email = ", email,password)
		if (email) {
			const emailDomain = getEmailDomain({ email })
			if (EMAIL_DOMAIN_BLACKLIST.includes(emailDomain)) return
		}
		console.log("In getUser, email = 2", email,password)
		user = await Network.API.Profile.User.get({ user, email, password, login })
		this.user = user
		if (login) {
			const loginRoute = await this.getLoginRoute({ user })
			console.log("In getUser, loginRoute = ", loginRoute)
			// history(loginRoute, { replace: true })
		}
		// console.log("In getUser, user after login = ", this.user)
		this.loadingData = false
		return user
	}

	async editUser({ payload, updateMessage }) {
		const updateAPI = this.user?.links?.update

		await Network.AxiosWrapper({
			token: this.user.token,
			method: updateAPI?.method,
			target: updateAPI?.url,
			payload,
			options: { disablePrefix: true }
		})

		if (updateMessage) {
			store.setNotification("notification", true, {
				msg: "Successfully updated your profile"
			})
		}
	}

	async removeUser({
		token,
		history,
		isFrontendOnly
	}) {
		try {
			this.clearLocalStorage()

			if (!Boolean(isFrontendOnly)) {
				await Network.AxiosWrapper({
					token: token,
					method: "POST",
					target: "user/v2/logout",

					payload: { all: true }
				})
			}

			this.user = {}
			if (!Boolean(isFrontendOnly)) {
				// history("/", { replace: true })
				window.location.href = "/"
			}
		} catch (err) {
			// history("/", { replace: true })
			window.location.href = "/"
		}
	}

	async invalidateUser({ }) {
		try {
			this.clearLocalStorage()
			this.user = {}
			window.location.pathname = "/"
		} catch (err) { }
	}

	async changeUserMode({ mode }) {
		try {
			this.user = new Network.API.Profile.User({
				...this.user,
				mode,
				login: false
			})
		} catch (err) {
			console.error(err)
		}
	}

	async changeUserEmployer({ user, employerId, history }) {
		try {
			clearLocalStorage({ type: "employer" })
			const payload = { userId: user.userId }

			await Network.AxiosWrapper({
				method: `PATCH`,
				target: `employer/${employerId}/attach`,
				payload,
				token: user.token
			})

			this.user.mode = this.user?.modesObject?.userModes?.find((mode) => (mode.id = "employer"))
			this.user.employer = null

			setTimeout(async () => {
				history("/dashboard")
			}, 100)
		} catch (err) {
			console.error(err)
		}
	}

	//

	setNotification = mobAction(function (action, status, template) {
		this.util[`${action}Status`] = status
		this.util[`${action}Template`] = template
	})

	setScroll(scrollY) {
		this.util.scrollY = scrollY
	}

	setGlobalMountConfig({ isMounted }) {
		this.util.globalMountConfig.isMounted = isMounted
	}

	async gotRouteHandler({ data, action }) {
		try {
			if (typeof action === "function") {
				action()
			}
			this.util.routeHandler.data = data
		} catch (err) {
			console.error(err)
		}
	}

	async sendMessage({ payload, user, disableNotification }) {
		const emailDomain = getEmailDomain({ email: payload.email })
		if (EMAIL_DOMAIN_BLACKLIST.includes(emailDomain)) return

		const url = "send/webContact"
		if (user?.id) payload.userId = user?.id

		await Network.AxiosWrapper({ method: "POST", target: url, payload })

		if (!disableNotification) {
			this.setNotification("notification", true, {
				severity: "success",
				msg: "Message sent successfully. We will respond to you shortly."
			})
		}

		return true
	}

	async historyHandle({ action, location, history }) {
		if (action === "PUSH") history(location?.target)
		else if (action === "POP") history(-1)
	}

	async updateCurrentRouteObject({ routeObject }) {
		store.browser.currentRouteObject = routeObject
	}

	setDisableInput({ status }) {
		this.disableInput = status
	}

	setConfirmConfig({ anchor, text, color, onCancel, onConfirm }) {
		this.confirmConfig.anchor = anchor
		this.confirmConfig.text = text
		this.confirmConfig.color = color
		this.confirmConfig.onCancel = onCancel
		this.confirmConfig.onConfirm = onConfirm
	}

	setScrollRef({ scrollRef }) {
		this.scrollRef = scrollRef
	}

	updateSkippedEnrollments({ add, clear }) {
		if (add) this.skippedEnrollments.push(add)
		else if (clear) this.skippedEnrollments = []
	}
}

const store = new Store()

export default store
